/**
 * The Aire's creatures (ADR 0068), read by `mobs.ts` with the rest of the
 * bestiary: Shefira, her brood, and the arena copies of the Company that
 * stand by the player in the story.
 *
 * Her stat block is the story's (one Warrior of level 20 and the Company);
 * a raid resizes her health and her blows at the instance's creation
 * (`raidScaling`, `rules/shefira.ts`). Her brood has its own body; hers is
 * drawn on her large canvas by the client, the yeti's standing in until it loads.
 */
export const ARENA_ALLY_IDS = [
    'aerie-tutor',
    'aerie-lookout',
    'aerie-forest-druid',
    'aerie-swamp-hunter',
    'aerie-jackal-priestess',
    'aerie-snow-warden',
];
/**
 * An arena ally's health (ADR 0068 §4): enough for its bar to drain in
 * visible blows. Nothing a player does touches it; the director paces its
 * wounds to the ally's written fall (`rules/story-allies.ts`).
 */
export const ARENA_ALLY_HEALTH = 900;
/** The creature each arena copy is drawn and named after. */
export const ARENA_ALLY_SOURCES = {
    'aerie-tutor': 'tutor',
    'aerie-lookout': 'lookout',
    'aerie-forest-druid': 'forest-druid',
    'aerie-swamp-hunter': 'swamp-hunter',
    'aerie-jackal-priestess': 'jackal-priestess',
    'aerie-snow-warden': 'snow-warden',
};
export const SHEFIRA_MOB_IDS = ['shefira', 'ember-whelp', ...ARENA_ALLY_IDS];
export const SHEFIRA_DEFINITIONS = {
    shefira: {
        id: 'shefira',
        name: 'Shefira',
        // Her body is her large canvas (`dragon.shefira-*`, drawn by the client's
        // `ShefiraView`); the yeti's stands in while her lazy atlases load, or if they fail.
        bodyKey: 'body.yeti',
        rank: 'dungeon-boss',
        level: 20,
        tilesPerSecond: 2,
        // The story's (`STORY_SCALING`); every fight sets its own at the instance's creation.
        health: 15_000,
        damage: 40,
        defence: 4,
        attackIntervalMs: 2200,
        // She holds the whole arena: whoever enters it is hers.
        aggroRange: 16,
        leashRange: 18,
        // An instance's fight: she is never back in the same room.
        respawnMs: 24 * 60 * 60_000,
        xp: 6000,
        wanderRadius: 0,
        restMs: 6000,
        loot: [],
    },
    'ember-whelp': {
        id: 'ember-whelp',
        name: 'Dragonnet de braise',
        bodyKey: 'body.ember-whelp',
        level: 18,
        tilesPerSecond: 4,
        health: 420,
        damage: 18,
        defence: 2,
        attackIntervalMs: 1400,
        aggroRange: 14,
        leashRange: 30,
        respawnMs: 60_000,
        xp: 0,
        wanderRadius: 0,
        loot: [],
    },
};
//# sourceMappingURL=shefira-mobs.js.map